import { render, staticRenderFns } from "./VDeleteModal.vue?vue&type=template&id=5ad69604&"
import script from "./VDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./VDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports